import Vue from "vue";

import LegacyRoutes from "./routes.vue";

Vue.component("legacy-routes", LegacyRoutes);
